import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

export default function RealityHeader() {
  const auth = useContext(AuthContext) || {};
  const { token, userInfo } = auth;
  const initial = String(
    userInfo?.displayName || userInfo?.username || userInfo?.email || "D"
  ).trim().slice(0, 1).toUpperCase();

  const openAccount = () => {
    if (token) {
      window.location.assign("/billing");
      return;
    }
    const next = `${window.location.pathname}${window.location.search || ""}${window.location.hash || ""}`;
    window.location.assign(`/login?next=${encodeURIComponent(next)}`);
  };

  return (
    <header className="reality-header">
      <a className="reality-brand" href="/" aria-label="TheDoAR home">DoAR</a>
      <nav aria-label="TheDoAR">
        <a href="/">Explore</a>
        <a href="/marketplace">Marketplace</a>
      </nav>
      <button
        type="button"
        className={`reality-account${token ? " is-signed-in" : ""}`}
        onClick={openAccount}
        aria-label={token ? "Open account and billing" : "Sign in"}
      >
        {token ? <><span className="reality-account__desktop">Account</span><span className="reality-account__mobile">{initial}</span></> : "Sign in"}
      </button>
    </header>
  );
}
